import { Grid, Text } from "@chakra-ui/react";
import { usePagedList } from "../../hooks/usePagedList";
import { Pagination } from "../Pagination";
import { COLORS } from "../../theme/dashboardTokens";

// Grid de mini-gráficos por indicador (1 por série), paginado — sem isso uma
// série com muitos indicadores empurra a página inteira pra baixo. Página de
// 6 (3 linhas de 2 colunas no layout xl já usado pelos dois dashboards).
export default function PaginatedIndicatorGrid({ indicators, renderCard, pageSize = 6 }) {
  const { pageItems, page, setPage, meta } = usePagedList(indicators, pageSize);

  if (!indicators || indicators.length === 0) {
    return (
      <Text color={COLORS.inkMuted} fontSize="14px">
        Nenhum indicador desta série com dado nos anos selecionados.
      </Text>
    );
  }

  return (
    <>
      <Grid templateColumns={{ base: "1fr", xl: "1fr 1fr" }} gap="20px">
        {pageItems.map(renderCard)}
      </Grid>
      {indicators.length > pageSize && (
        <Pagination currentPage={page} onPageChange={setPage} meta={meta} viewing={pageItems.length} />
      )}
    </>
  );
}
